import { render, staticRenderFns } from "./wxDetails.vue?vue&type=template&id=402a4826&scoped=true&"
import script from "./wxDetails.vue?vue&type=script&lang=js&"
export * from "./wxDetails.vue?vue&type=script&lang=js&"
import style0 from "./wxDetails.vue?vue&type=style&index=0&id=402a4826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a4826",
  null
  
)

export default component.exports